module.exports = __webpack_public_path__ + "img/imgdunab.4a95f30f.png";